import { render, staticRenderFns } from "./CreateTreatment.vue?vue&type=template&id=0061b05e&lang=pug&"
import script from "./CreateTreatment.vue?vue&type=script&lang=ts&"
export * from "./CreateTreatment.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTreatment.vue?vue&type=style&index=0&id=0061b05e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports